import { REPRESENTATION } from './constants'
import { NONE } from '../../constants'

export const appointment = (appointments) =>
  Object.keys(appointments)
    .filter(key => appointments[key])
    .map(key => REPRESENTATION[key])
    .join(', ')
  || NONE
